export default __webpack_public_path__ + "static/media/svgartista.032ba57c.webp";